import {
  BoldType,
  createToolbarComponent,
  HotkeyUtilities,
  MarkButton,
} from '@shopify/online-store-ui';
import {useI18n} from '@shopify/react-i18n';

import {bold} from './icons';

export const Bold = createToolbarComponent(BoldType, (props) => {
  const [i18n] = useI18n();
  const {hotkey} = props.plugin;
  if (!hotkey) {
    throw Error('No hotkey provided for bold plugin');
  }
  const tooltip = props.disabled
    ? null
    : i18n.translate('tooltip', {
        hotkey: HotkeyUtilities.formatHotKeys(hotkey),
      });

  return (
    <MarkButton
      {...props}
      icon={bold}
      tooltip={tooltip}
      disabled={props.disabled}
    />
  );
});
